import React from "react";
import PageHeader from "../../../Component/BasicComponents/HeaderBreadCrumbs";
import ReusbaleHigherOrderForm from './ReusbaleHigherOrderForm/ReusbaleHigherOrderForm'
import FormWithTabs from "./ReusbaleHigherOrderForm/FormWithTabs";
import { useAccessControl, useAddOrUpdateCompanyConfiguration, useCompanyConfiguration } from "./hooks/useConfiguration";
import CompanyConfigurationForm from "./ReusbaleHigherOrderForm/CompanyConfigurationForm";
import AccessControlForm from "./ReusbaleHigherOrderForm/AccessControlForm";


// const CompanyConfigurationScreen = ()=>{

const CompanyConfigurationScreen = () => {
  const { data: getCompanyConfiguration, isSuccess } = useCompanyConfiguration({ enable: true });
  const { data: getAccessControl } = useAccessControl({ enable: true });




  



  return (
    <div className="p-2">
      <div style={{ width: "100%", /*marginLeft: "2%" */ }}>
        <PageHeader title="Company Confiuration" />
      </div>

      {/* <div className="col-md-12 mt-3" style={{ marginLeft: "2%" }}> */}
      <CompanyConfigurationForm
          data={getCompanyConfiguration}
        />
         <AccessControlForm
          data={isSuccess ? getAccessControl : {}}
        />
      {/* </div> */}
       
   


    <div className="col-md-12 mt-3" /*style={{marginLeft:'2%'}} */>
    < FormWithTabs/>
      </div>
    </div>
  );
};
export default CompanyConfigurationScreen;
